<template>
    <button class="button is-fullwidth" @click="getExcel()" :class="{ 'is-loading' : isLoading }">EXCEL DOWNLOAD</button>
</template>

<script>

export default {
   methods: {
       getExcel() {
           this.$store.dispatch('downloadProfitSectionInvoicesExcel');
       }
   },
   computed: {
       isLoading() {
           return this.$store.getters.getProfitSectionData.is_loading
       }
   },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Profit/ProfitExcelButton.vue